import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// El código lee las claves de las variables de entorno que configuraste en Netlify.
// Asegúrate de que los nombres coincidan exactamente.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID
};

// Inicializa los servicios de Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
// Por defecto las Cloud Functions se despliegan en us-central1
const functions = getFunctions(app, 'us-central1');

// Configurar Firebase Functions para evitar CORS usando el emulador en desarrollo local
// y configuración especial en producción
if (process.env.NODE_ENV === 'development') {
  // En desarrollo local, usar emulador si está disponible
  try {
    console.log('🔧 Configurando Firebase Functions para desarrollo');
    // connectFunctionsEmulator(functions, "localhost", 5001);
  } catch (error) {
    console.log('ℹ️ Emulador no disponible, usando funciones en la nube');
  }
} else {
  // En producción, configurar timeout personalizado
  console.log('🔧 Configurando Firebase Functions para producción con timeout extendido');
}

// QA local contra los emuladores (Firestore + Auth), sin tocar producción.
// Se activa solo en desarrollo y con REACT_APP_USE_EMULATOR=true:
//   firebase emulators:start --only firestore,auth
//   $env:REACT_APP_USE_EMULATOR='true'; npm start
// REACT_APP_FIRESTORE_EMULATOR_PORT cambia el puerto si el 8080 está ocupado.
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATOR === 'true') {
  console.log('🧪 Firebase apuntando a los emuladores locales');
  const firestorePort = Number(process.env.REACT_APP_FIRESTORE_EMULATOR_PORT) || 8080;
  connectFirestoreEmulator(db, '127.0.0.1', firestorePort);
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
}

const provider = new GoogleAuthProvider();
// Siempre el selector de cuentas: con la sesión de un Gmail personal abierta en el
// navegador, Google entraría con esa sin preguntar y la planilla la rechazaría.
provider.setCustomParameters({ prompt: 'select_account' });

// Exporta los servicios para ser usados en otras partes de la aplicación
export { auth, provider, db, functions, storage };
